import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { parseDateBR } from 'helpers/date';
import { Button, Table } from 'react-bootstrap';

import ActionStatus from 'enums/ActionStatus';
import style from './style.module.scss';
import ReactDOMServer from 'react-dom/server';
import convertToAscii from 'helpers/ConvertToASCII';
import { api } from 'services/api';

const ExportTable = ({
  planName,
  id,
  company,
  projectName,
  funds,
  actions,
}) => {
  const [totalFunds, setTotalFunds] = useState(0);
  const [totalFundsReal, setTotalFundsReal] = useState(0);
  const [isExport, setExport] = useState(true);
  const [isExport2, setExport2] = useState(true);
  const [actionsAux, setActionsAux] = useState([]);
  const { t } = useTranslation();

  const statusName = (status_id) => {
    switch (status_id) {
      case ActionStatus.Draft:
        return 'draft';
      case ActionStatus.OnApproval:
        return 'on_approval';
      case ActionStatus.Disapproved:
        return 'disapproved';
      case ActionStatus.AwaitingArts:
        return 'awaiting_arts';
      case ActionStatus.ArtsApproval:
        return 'arts_approval';
      case ActionStatus.DisapprovedArts:
        return 'disapproved_arts';
      case ActionStatus.AwaitingComprovations:
        return 'awaiting_comprovations';
      case ActionStatus.ComprovationsApproval:
        return 'comprovations_approval';
      case ActionStatus.DisapprovedComprovations:
        return 'disapproved_comprovations';
      case ActionStatus.AwaitingReceipt:
        return 'awaiting_receipt';
      case ActionStatus.Finished:
        return 'finished';
      case ActionStatus.Cancelled:
        return 'canceled';
      case ActionStatus.OnExecution:
        return 'on_execution';
      case ActionStatus.ControllingApproval:
        return 'controlling_approval';
    }
  };

  useEffect(()=>{
    setExport(true);
    api.get('actions', { params: {
      marketing_plan_id: id,
    } }).then(({ data }) => {
      setActionsAux(data.data);
      setExport(false);
    });
  },[actions])

  useEffect(() => {
    setExport2(true);
    let sum = 0;
    let sumReal = 0;

    if (funds !== false) {
      funds.map(a=>{
        a.actionValues = a.actionValues.filter(b=>b.action.marketing_plan_id === parseInt(id));
        return a;
      }).forEach(a=>{
        let aux_used_in_plan = 0;
        let aux_used_in_plan_real = 0;
        a.actionValues.forEach(b=>{
          aux_used_in_plan_real += (b.actual_value*(a.value_cotacao?parseFloat(a.value_cotacao):1) + (b.funds_expire_value ? (b.funds_expire_value*(a.value_cotacao?parseFloat(a.value_cotacao):1) ) : 0));
          aux_used_in_plan += (b.actual_value + (b.funds_expire_value ? (b.funds_expire_value) : 0));
        });
        sumReal += aux_used_in_plan_real;
        sum += aux_used_in_plan;
      })
      setTotalFunds(sum);
      setTotalFundsReal(sum);
      setExport2(funds.length == 0);
    }

  }, [funds]);

  const getCurrency = (currency) => {
    switch (currency.toString()) {
      case '1':
        return 'R$';
        break;
      case '2':
        return '$';
        break;
      case '3':
        return '€';
        break;
      default:
        break;
    }
  };

  const getLocale = (currency) => {
    switch (currency.toString()) {
      case '1':
        return 'pt-BR';
        break;
      case '2':
        return 'pt-BR';
        break;
      case '3':
        return 'eu';
        break;
      default:
        break;
    }
  };

  const exportar = () => {
    setExport(true);
    var a = document.createElement('a');
    var data_type = 'data:application/vnd.ms-excel; charset=UTF-8';
    var table_div = (
      <table id="teste">
      <thead>
        <tr>
          <td colSpan="2">
            {t('title:marketing plan register')} - Vendor: {company}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{t('label:id')}</td>
          <td>{id}</td>
        </tr>
        <tr>
          <td>{t('label:company')}</td>
          <td>{company}</td>
        </tr>
        <tr>
          <td>{t('label:plan name')}</td>
          <td>{planName}</td>
        </tr>
        <tr>
          <td>{t('label:project name')}</td>
          <td>{projectName}</td>
        </tr>
        <tr></tr>
        <tr>
          <td colSpan="2">{t('label:funds')}</td>
        </tr>
        <tr>
          <td>{t('label:type')}</td>
          <td>Moeda</td>
          <td>Cotação</td>
          <td>{t('label:used in plan')}</td>
        </tr>
        {funds !== false
          ? funds.map(a=>{
            a.actionValues = a.actionValues.filter(b=>b.action.marketing_plan_id === parseInt(id));
            return a;
          }).map((fund, k) => {
            var used_in_plan = 0;
            fund.actionValues.forEach(a=>{
              used_in_plan += a.actual_value + (a.funds_expire_value ?? 0);
            });

            return (
              <tr key={k}>
                <td className="text-center align-middle">
                  {t(`label:${fund.type.name}`)}
                </td>
                <td className="text-center align-middle">
                  {getCurrency(fund.type.currency_id)}
                </td>
                <td className="text-center align-middle">
                  {fund.value_cotacao}
                </td>
                <td className="text-center align-middle">
                  {used_in_plan}
                </td>
              </tr>
            );
          })
          : ''}
        <tr>
          <td>{t('label:total')}</td>
          <td></td>
          <td></td>
          <td>
            {totalFunds}
          </td>
        </tr>
        <tr></tr>
        <tr>
          <td>{t('label:actions')}</td>
        </tr>
        <tr>
          <td style={{textAlign:'center'}}>{t('label:status')}</td>
          <td>{t('label:id')}</td>
          <td>ID fabricante</td>
          <td>{t('label:name')}</td>
          <td>{t('label:activity')}</td>
          <td>{t('label:activity type')}</td>
          <td>{t('label:start date')}</td>
          <td>{t('label:end date')}</td>
          <td>{t('label:payment date')}</td>
          <td>{t('label:value')}</td>
          <td>{t('label:expected value')}</td>
          <td>Moeda</td>
        </tr>
        {typeof actionsAux === 'undefined'
          ? ''
          : actionsAux.map((action) => {
            return (
              <tr key={action.id}>
                <td>{t(`statuses:${statusName(action.status_id)}`)}</td>
                <td>{action.company_id}</td>
                <td>{action.vendor_id?action.vendor_id:'--'}</td>
                <td>{action.action_name}</td>
                <td>{action.task_name}</td>
                <td>{action.task_task_group_name}</td>
                <td>{action.start_date ? parseDateBR(action.start_date) : '--'}</td>
                <td>{action.end_date ? parseDateBR(action.end_date) : '--'}</td>
                <td>{action.payment_date ? parseDateBR(action.payment_date) : '--'}</td>
                <td>
                  {action.total_value ? 
                  action.total_value : 
                  "0"}
                </td>
                <td>
                  {action.expected_value}
                </td>
                <td>
                  {getCurrency(action.currency)}
                </td>
              </tr>
            );
          })}
      </tbody>
      </table>
    );

    table_div = (`
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
      <head>
        <!--[if gte mso 9]>
          <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                      <x:Name>marketing-plan</x:Name>
                      <x:WorksheetOptions>
                        <x:DisplayGridlines/>
                      </x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
        <![endif]-->
        <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
      </head>
      <body>
        ${convertToAscii(ReactDOMServer.renderToString(table_div), [160])}
      </body>
    </html>`
    );
  
    var table_html = escape(table_div);
    a.href = data_type + ', ' + table_html;
    a.download = 'marketing-plan.xls';
    a.click();
    setExport(false);
  };

  return (
    <>
      <Button disabled={isExport || isExport2}
        onClick={exportar}>{t('label:export plan')}
      </Button>
    </>
  );
};

export default ExportTable;
